import { Session } from '../../../core/business-objects/session/session.model';

export interface IOnlineStatusModelArgs {
    accountId: string;
    busy: boolean;
    isOnline: boolean;
    isSignedIn: boolean;
}

export interface IOnlineStatusModelGetInstanceArgs {
    accountId: string;
    session: Session;
    busy: boolean;
}

export class OnlineStatusModel {
    protected _accountId: string;
    protected _busy: boolean;
    protected _isOnline: boolean;
    protected _isSignedIn: boolean;

    static getInstance(args: IOnlineStatusModelGetInstanceArgs): OnlineStatusModel {
        return new OnlineStatusModel({
            accountId: args.accountId,
            isOnline: args.session.getNetworkStatus().isOnline(),
            isSignedIn: args.session.isSignedIn() && args.session.getNetworkStatus().isAuthenticated(),
            busy: args.busy
        });
    }

    constructor(args?: IOnlineStatusModelArgs) {
        Object.keys(args).forEach(key => {
            this[`_${key}`] = args[key];
        });
    }

    get accountId(): string {
        return this._accountId;
    }

    get busy(): boolean {
        return this._busy;
    }

    get isOnline(): boolean {
        return this._isOnline;
    }

    get isSignedIn(): boolean {
        return this._isSignedIn;
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/online-status/online-status.model.ts